import { API_PREFIX } from '@shared/globals';
import axios from 'axios';
const invitationApi = 'api/getApi';

export default {
    name: 'loggedIn',
    namespaced: true,
    state: {
        isResuming: null,
        buyerName: '',
        linkingUser: null,
        invitationCode: '',
        newFeatureIdc: false
    },
    mutations: {
      updateLinkingUser(state, linkingUser) {
          state.linkingUser = linkingUser;
      },
      updateIsResuming(state, isResuming) {
          state.isResuming = isResuming;
      },
      updateBuyerName(state, buyerName) {
          state.buyerName = buyerName;
      },
      setLoggedInInvCode(state, invitationCode) {
          state.invitationCode = invitationCode;
      },
      setNewFeatureIdc(state, newFeatureIdc) {
          state.newFeatureIdc = newFeatureIdc;
      }
    },
    getters: {

    },
    actions: {
      logout({state, rootGetters}){
        return rootGetters[invitationApi]
            .post(`/${state.invitationCode}`)
            .then((response) => {
                window.location.replace(`/invitation/${state.invitationCode}`)
            })
            .catch((error) => {
                console.error(error);
            });
      },
      getNewFeatureIdc({commit}) {
          let apiOptions = {
              baseURL: `/${API_PREFIX}/receivables/api/`,
              headers: {},
              withCredentials: true
          }
          return axios.create(apiOptions)
              .get('/new/feature/idc')
              .then((payload) =>{
                  commit('setNewFeatureIdc', payload.data === 'Y')
              })
      }

    },
};



// WEBPACK FOOTER //
// ./shared/store/modules/loggedIn.js